import Typography from "@material-ui/core/Typography";
import React from "react";
import Box from "@material-ui/core/Box";
import {makeStyles} from '@material-ui/core/styles';
import {FooterStyles} from '../styles/dashboard';


const useStyles = makeStyles(FooterStyles);

export default function DashboardFooter() {
    const classes = useStyles();
    return (
        <React.Fragment>

            <Box className={classes.footerPanel} display="flex" alignItems="center" justifycontent="center">
                <div>
                    <Typography className={classes.footerText} variant="body2" color="textSecondary" align="center">
                        <br/>
                        {'© Copyright '}
                        {new Date().getFullYear() + ' '}
                        by Boost Acquisition, Inc. All rights reserved.
                    </Typography>
                </div>
            </Box>
        </React.Fragment>
    );
}
